import { Flex } from 'antd'
import { useEffect, useState } from 'react'

import { useFramework } from '@suntex.fim/framework'
import { LevelSelect } from '@suntex.fim/ui'

type WDYKTemplate = {
  id?: number
  grade?: number
  topic?: string
}

type DropdownExampleProps = {
  data: WDYKTemplate[]
  setTemplateId: (id: number | undefined) => void
}

function GroupDropDown({ data, setTemplateId }: DropdownExampleProps) {
  const { localization } = useFramework()
  // Extract unique grades
  const grades = Array.from(new Set(data.map((item) => item.grade)))
  const gradeOptions = grades.map((grade) => ({
    label: String(grade),
    key: Number(grade) || 0
  }))

  // Set initial grade and topics
  const initialGrade = grades[0]
  const initialTopics = data
    .filter((item) => item.grade === initialGrade)
    .map((item) => item.topic)

  const [selectedGrade, setSelectedGrade] = useState<
    number | undefined | string
  >(initialGrade)
  const [topics, setTopics] = useState<(string | undefined)[]>(initialTopics) // Topics for the initial grade
  const [selectedTopic, setSelectedTopic] = useState<string>(
    initialTopics[0] || ''
  )
  const [topicOptions, setTopicOptions] = useState<
    {
      label: string
      key: string
    }[]
  >([])

  // Update topics and selectedTopic when grade changes
  const handleGradeChange = (grade: number | string) => {
    setSelectedGrade(grade)
    const filteredTopics = data
      .filter((item) => item.grade === grade)
      .map((item) => item.topic)
    setTopics(filteredTopics)
    setSelectedTopic(filteredTopics[0] || '') // Default to the first topic of the new grade
  }
  const hableTemplateId = (
    selectedGrade: number | string,
    selectedTopic: string
  ) => {
    const matchedItem = data.find(
      (item) => item.grade === selectedGrade && item.topic === selectedTopic
    )
    setTemplateId(matchedItem?.id || 0)
  }
  useEffect(() => {
    setSelectedGrade(initialGrade)
    setTopics(initialTopics)
    setSelectedTopic(initialTopics[0] || '')
    if (initialGrade && initialTopics[0]) {
      hableTemplateId(initialGrade, initialTopics[0])
    }
  }, [initialGrade])
  useEffect(() => {
    const options = topics.map((topic) => ({
      label: topic || '',
      key: topic || ''
    }))
    setTopicOptions(options)
  }, [topics])

  // Update templateId whenever selectedGrade or selectedTopic changes
  useEffect(() => {
    if (selectedGrade && selectedTopic) {
      hableTemplateId(selectedGrade, selectedTopic)
    }
  }, [selectedGrade, selectedTopic])

  return (
    <Flex gap={10}>
      <div className="report-filter wdyk-dropdown__select">
        <p className="dd-label fw-bold text-sm">
          {localization.text('Grade')}:
        </p>
        <LevelSelect
          value={selectedGrade}
          onChange={(newGrade) => handleGradeChange(newGrade)}
          options={gradeOptions}
        />
      </div>
      <div className="report-filter wdyk-dropdown__topicselect">
        <p className="dd-label fw-bold text-sm">Topic:</p>
        <LevelSelect
          value={selectedTopic}
          onChange={(newTopic) => setSelectedTopic(String(newTopic))}
          options={topicOptions}
        />
      </div>
    </Flex>
  )
}

export default GroupDropDown
